import { setupIntersectionObserver } from './imageLazyLoad';

function imageLazyLoadMutationObserver() {
	if (window.MutationObserver) {
		const getLazyImages = (acc, node) => {
			if (node.nodeType === 1) {
				const lazyImageClassName = 'image-lazy-load';
				const lazyImageNodeElements =
					node.getElementsByClassName(lazyImageClassName);

				if (node.classList.contains(lazyImageClassName)) {
					return [...acc, node];
				}

				if (lazyImageNodeElements.length > 0) {
					return [...acc, [...lazyImageNodeElements]];
				}

				return acc;
			}

			return acc;
		};

		const processMutation = (acc, domMutation) => {
			const lazyImages = [...domMutation.addedNodes].reduce(getLazyImages, []);
			return acc.concat(lazyImages);
		};

		const maybeSetupIntersectionObserver = domMutations => {
			// process the array of new mutations
			const lazyImagesArray = domMutations.reduce(processMutation, []);

			if (lazyImagesArray.length) {
				// pass the flattened array of new images to the imported IntersectionObserver function
				setupIntersectionObserver(lazyImagesArray.flat());
			}
		};

		const mutObserver = new MutationObserver(maybeSetupIntersectionObserver);

		mutObserver.observe(document.documentElement, {
			childList: true,
			subtree: true,
		});
	}
}

export default imageLazyLoadMutationObserver;
